<template>
	<div class="content">
		<div class="last-eat">
			<div v-if="internalTime">已经{{ oppositeStatusText }}: <span class="bold-font ">{{ internalTime }}</span>小时
				(<span class="bule-font" @click="refreshPage">刷新</span>)
			</div>
			<div v-if="lastSleepTime">上次睡了: <span class="bold-font">{{ lastSleepTime }}</span></div>
		</div>
		<div class="time_select" :class="{ time_selected: selectTimeIndex > -1 }">
			<van-button type="primary" :class="{ selected_button: selectTimeIndex === 60 }"
				@click="selectedTime(60)">一小时前</van-button>
			<van-button type="info" :class="{ selected_button: selectTimeIndex === 30 }"
				@click="selectedTime(30)">30分钟前</van-button>
			<van-button type="warning" :class="{ selected_button: selectTimeIndex === 15 }"
				@click="selectedTime(15)">15分钟前</van-button>
			<van-button type="danger" :class="{ selected_button: selectTimeIndex === 5 }"
				@click="selectedTime(5)">5分钟前</van-button>
		</div>
		<div class="current_time">
			<div class="custom_time">自定义时间(几分钟前):<van-field type="digit" @input="inputCustomTime" v-model="customTime"
					label="" :placeholder="`多少分钟前${statusText}`" /></div>
		</div>
		<div class="final_data">
			<div>
				<div>时间：<span class="red-font bold-font">{{ sleepTime }}</span></div>
			</div>
			<van-button plain type="primary" @click="recordSleep">记录{{ statusText }}时间</van-button>
		</div>
		<div class="data-list" v-if="dataList.length > 0">
			<div class="data-list-item data-list-header">
				<span class="data-list_interval">时长</span>
				<span class="data-list_time">时间</span>
				<span class="data-list_operate">操作</span>
			</div>
			<!-- <van-list> -->
			<div class="data-list-content">
				<div class="data-list-item" v-for="item in dataList" :key="item.id">
					<span class="data-list_interval">{{ item.interval }}</span>
					<span class="data-list_time">
						<span>{{ item.startTime }}</span>
						<span>{{ item.endTime }}</span>
					</span>
					<span class="data-list_operate">
						<van-button type="danger" size="small" @click="deleteSleepRecord(item.id)">删除</van-button>
					</span>
				</div>
			</div>

			<!-- </van-list> -->
		</div>
	</div>
</template>

<script>
import {
	getSleepList,
	deleteSleepRecord,
	getTotalListByDate,
	addSleepRecord
} from '../util/api'
import { Dialog } from 'vant';
export default {
	name: 'SleepCom',
	data() {
		return {
			selectTimeIndex: -1,
			selectNumIndex: -1,
			customTime: null,
			customNum: null,
			sleepTime: new Date().toLocaleString(),
			eatNum: 0,
			lastSleepTime: null,
			lastEatNumber: null,
			internalTime: null,
			intervalId: null,
			dataList: [],
			totalNum: 0,
			isSleep: false
		}
	},
	methods: {
		refreshPage: () => {
			location.reload()
		},
		getSleepList: function () {
			getSleepList({
				startDate: this.getPastMonthDate(13),
				endDate: this.getPastMonthDate(0)
			}).then((res) => {
				const data = res.data;
				const dataNew = data.map((item) => {
					if (item.startTime && item.endTime) {
						item.interval = `${this.computedInterval(item.startTime, item.endTime)}h`
					} else {
						item.interval = null
					}
					return item
				})
				this.handleData(dataNew);
				this.getTotalListByDate();
			})
		},
		getTotalListByDate() {
			const date = new Date()
			const todayDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
			getTotalListByDate({ startDate: todayDate, endDate: todayDate }).then((res) => {
				if (res?.data?.length > 0) {
					this.totalNum = res.data[0].total
				} else {
					this.totalNum = 0
				}
			})
		},
		handleData: function (data) {
			this.dataList = data || []
			if (data.length === 0) return
			const lastItem = data[0]
			if (lastItem.endTime) {
				this.$set(this, 'internalTime', null);
				this.$set(this, 'lastSleepTime', lastItem.interval);
				this.$set(this, 'isSleep', false);
			} else {
				if (data.length > 1) {
					this.$set(this, 'lastSleepTime', data[1].interval);
				} else {
					this.$set(this, 'lastSleepTime', null);
				}
				this.$set(this, 'internalTime', `${this.computedInterval(lastItem.startTime, new Date())}h`);
				this.$set(this, 'isSleep', true);
			}
		},
		recordSleep: function () {
			getSleepList({
				startDate: this.getPastMonthDate(6),
				endDate: this.getPastMonthDate(0)
			}).then((res) => {
				const data = res.data;
				if (data.length > 0 && !data[0].endTime) {
					this.updateRecord(data[0].id)
				} else {
					this.addNewRecord();
				}
			})
			this.$set(this, 'isSleep', !this.isSleep);
		},
		addNewRecord() {
			addSleepRecord({
				startTime: this.sleepTime,
			}).then(() => {
				this.getSleepList();
				this.clearSelectedData();
			})
		},
		updateRecord(id) {
			addSleepRecord({
				id: id,
				endTime: this.sleepTime,
			}).then(() => {
				this.getSleepList();
				this.clearSelectedData();
			})
		},
		clearSelectedData() {
			this.$set(this, 'customTime', null);
			this.$set(this, 'selectTimeIndex', -1);
			this.$set(this, 'sleepTime', this.computeTime(0));
		},
		deleteSleepRecord: function (id) {
			Dialog.confirm({
				message: '确认删除这次记录吗'
			}).then(() => {
				deleteSleepRecord({
					id: id
				}).then(() => {
					this.getSleepList()
				})
			})

		},
		selectedTime: function (index) {
			const isCancel = index === this.selectTimeIndex
			if (isCancel) {
				this.$set(this, 'selectTimeIndex', -1);
			} else {
				this.$set(this, 'selectTimeIndex', parseInt(index));
			}
			this.$set(this, 'customTime', null);
			this.$set(this, 'sleepTime', this.computeTime(isCancel ? 0 : parseInt(index)));
		},
		computeTime: (minute) => {
			const now = new Date();
			now.setMinutes(now.getMinutes() - minute);
			return now.toLocaleString()
		},
		inputCustomTime: function () {
			if (this.customTime) {
				this.$set(this, 'selectTimeIndex', -1);
				this.$set(this, 'sleepTime', this.computeTime(this.customTime));
			}
		},
		inputCustomNum: function () {
			if (this.customNum) {
				this.$set(this, 'selectNumIndex', -1);
				this.$set(this, 'eatNum', this.customNum);
			}
		},

		getPastMonthDate(daysAgo) {
			const today = new Date();
			const needDaysAgo = new Date(today.setDate(today.getDate() - daysAgo));
			const year = needDaysAgo.getFullYear();
			const month = needDaysAgo.getMonth() + 1; // 月份是从0开始的，所以加1
			const date = needDaysAgo.getDate();
			return `${year}-${month}-${date}`;
		},
		computedInterval(startTime, endTime) {
			return ((new Date(endTime).getTime() - new Date(startTime).getTime()) / (1000 * 60 * 60)).toFixed(2)
		}
	},
	mounted() {
		this.getSleepList();
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
		this.intervalId = setInterval(() => {
			this.getSleepList()
		}, 20000);
	},
	computed: {
		statusText() {
			return this.isSleep ? "睡醒" : "睡着"
		},
		oppositeStatusText() {
			return this.isSleep ? "睡着" : "睡醒"
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	padding: 12px 24px 0;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
}

.time_select {
	display: flex;
	justify-content: space-around;
	padding: 10px 0;
	gap: 6px;

}

.time_select /deep/ .van-button {
	flex: 1 !important;
	padding: 0 8px;
}

.time_selected /deep/ .van-button {
	opacity: 0.2;
}

.time_selected /deep/ .selected_button {
	opacity: 1;
}

.today-num {
	display: flex;
	justify-content: space-between;
}

.current_time {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid #ececec;
}

.custom_time {
	display: flex;
	align-items: center;
}

.final_data {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	padding: 12px 0;
	border-bottom: 1px solid #ececec;

	>div {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
}

.final_data>div {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.custom_time /deep/ .van-field {
	width: 150px;
	padding: 0;
	margin: 6px;
}

.data-list-header {
	margin-bottom: 12px;
}

.data-list {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: auto;
	margin-top: 12px;
	margin-bottom: 6px;
}

.data-list-item {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}

.data-list_time {
	display: flex;
	flex-direction: column;
	flex: 1;
}

.data-list_operate {
	width: 50px;
}

.data-list_num {
	width: 72px;
}

.data-list_interval {
	width: 72px;
}

.data-list-content {
	height: 360px;
	overflow-y: auto;
	flex: 1;
	font-size: 14px;
}

.last-eat {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.bule-font {
	color: #1989fa;
}

.red-font {
	color: #ee0a24;
}

.bold-font {
	font-weight: bold;
}

.red-font {
	color: #ee0a24;
}
</style>
